import * as React from 'react';
import { Checkbox, FormControlLabel } from "@mui/material";
import { CONTENTS_TYPE } from '../../const/general'

export default function Checkbox3D(props) {
    return (
        props.contentType !== CONTENTS_TYPE.IMAGE &&
        <FormControlLabel control={
            <Checkbox
                {...props.register}
                checked={props.getValues(props.setValueName) ?? props.isPermit3d}
                onChange={() => 
                    props.setValue(props.setValueName, 
                        !props.getValues(props.setValueName))}
            />}
            label="3Dを作成する"
        />
    );
}
